import YouTubeIframeLoader from 'youtube-iframe';
import Vimeo from '@vimeo/player';

class Video {
  static init(...parameters) {
    return new Video(...parameters);
  }

  constructor(container) {
    this.container = container;
    if (container) {
      this.content = container.querySelector('.content');
      this.video = container.querySelector('.video');
      this.paused = true;
      if (this.video) {
        this.videoType = this.video.dataset.videoType;
        this.videoStart = this.video.dataset.videoStart;

        if (this.videoType === 'youtube') {
          this.initYotube();
        }

        if (this.videoType === 'vimeo') {
          this.initVimeo();
        }
      }
    }
  }

  initYotube() {
    const { video } = this;

    const player = video.querySelector('.player');
    const { videoId } = video.dataset;
    if (player && videoId) {
      YouTubeIframeLoader.load((YT) => {
        this.youtube = new YT.Player(player, {
          height: '100%',
          width: '100%',
          videoId,
          events: {
            onReady: () => {
              this.iframe = video.querySelector('iframe');
            },
          },
          playerVars: {
            start: this.videoStart,
            controls: 0, // Show pause/play buttons in player
            showinfo: 0, // Hide the video title
            modestbranding: 1, // Hide the Youtube Logo
            fs: 0, // Hide the full screen button
            cc_load_policy: 0, // Hide closed captions
            iv_load_policy: 3, // Hide the Video Annotations
            autohide: 0,
            rel: 0, // Hide video controls when playing
            disablekb: 1, // disable the keyboard controls
          },
        });
      });
    }
  }

  initVimeo() {
    this.iframe = this.video.querySelector('iframe');

    const player = this.video.querySelector('.player');
    if (player) {
      let isReady = false;
      const vimeo = new Vimeo(player);
      vimeo.ready().then(() => {
        vimeo.setCurrentTime(this.videoStart);
      });
      vimeo.on('play', () => {
        if (!isReady) {
          isReady = true;
          this.onReady();
        }
        vimeo.on('timeupdate', (data) => {
          if (data.percent > 0) {
            vimeo.off('timeupdate');
            this.paused = false;
          }
        });
      });
      vimeo.on('pause', () => {
        vimeo.off('timeupdate');
        this.paused = true;
      });
      vimeo.getPaused().then((paused) => {
        if (!paused) {
          if (!isReady) {
            isReady = true;
            this.onReady();
          }
        } else {
          vimeo.off('timeupdate');
        }
        this.paused = paused;
      });
      this.vimeo = vimeo;
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-video', Video.init);
}
